import { useEffect } from "react";
import Warehouse from '../table/Tablewarehouse';
import Modal from "../modal/Modaladdwarehouse"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Warehouse/>
    
     </>
  );
};

export default Dashboard;
